import React from "react";
import useStyles from "./styles";
import { FormGroup, InputBase, FormHelperText } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import PostalCode from "../../PostalCode";
import ApmPayButton from '../ApmPayButton';

const GiroPay = ({ currentPaymentSystem, formik, errorString }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      <FormGroup className={classes.cardForm}>
        <p className={`${classes.cardText} input_label_text`}>{t('Payer_name')}</p>
        <InputBase
          error={!!(formik.errors.cardName)}
          className={classes.cardInput}
          label={t('Payer_name')}
          name="cardName"
          value={formik.values.cardName?.toUpperCase()}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          variant="outlined"
          placeholder={t('Payer_name')}
          fullWidth
          inputProps={{
            maxLength: 100,
          }}
        />
        {
          formik.errors?.cardName && (
            <FormHelperText className='error_text' error>{formik.errors?.cardName}</FormHelperText>
          )
        }
      </FormGroup>
      <FormGroup className={classes.cardForm}>
        <p className={`${classes.cardText} input_label_text`}>{t('Payer_City')}</p>
        <InputBase
          error={!!(formik.errors.city)}
          className={classes.cardInput}
          label={t('Payer_City')}
          name="city"
          value={formik.values.city?.toUpperCase()}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          variant="outlined"
          placeholder={t('Payer_City')}
          fullWidth
          inputProps={{
            maxLength: 100,
          }}
        />
        {
          formik.errors?.city && (
            <FormHelperText className='error_text' error>{formik.errors?.city}</FormHelperText>
          )
        }
      </FormGroup>
      <PostalCode formik={formik} className={`${classes.cardForm} input_label_text`} isApmShown={true} />
      <ApmPayButton currentPaymentSystem={currentPaymentSystem} errorString={errorString} />
    </div>
  )
}

export default GiroPay
